import { HTMLProps } from "react";
import { twMerge } from "tailwind-merge";

export const LegacyCard = (props: HTMLProps<HTMLDivElement>) => (
  <div
    {...props}
    className={twMerge("rounded-lg bg-white p-4", props.className)}
  />
);

export const LegacyCardHeader = (props: HTMLProps<HTMLDivElement>) => (
  <div
    {...props}
    className={twMerge(
      "rounded-t-lg border-b border-solid border-gray-200 bg-white p-4",
      props.className,
    )}
  />
);

export const LegacyCardContent = (props: HTMLProps<HTMLDivElement>) => (
  <div
    {...props}
    className={twMerge("rounded-b-lg bg-white p-4", props.className)}
  />
);
